import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { hasPermission } from "../models/permissions.model";

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isAuthenticated() ? true : router.createUrlTree(["/login"]);
};

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isAuthenticated() ? router.createUrlTree(["/dashboard"]) : true;
};

export function permissionGuard(
  permission: string,
  altPermissions: string[] = [],
): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const user = auth.currentUser();
    if (!user) return router.createUrlTree(["/login"]);
    if (hasPermission(user, permission)) return true;
    if (altPermissions.some((p) => hasPermission(user, p))) return true;
    return router.createUrlTree(["/dashboard"]);
  };
}

/** @deprecated Utiliser permissionGuard('staff.manage') */
export const managerGuard = permissionGuard("staff.manage");

/** @deprecated Utiliser permissionGuard('payments.manage') */
export const cashierGuard = permissionGuard("payments.manage");
